/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import LinksComponent1 from './components/links1';

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienAbout23Data } from './obrien-about23.data';
import { IObrienAbout23Props } from './obrien-about23.props.autogenerated';

export interface IObrienAbout23ViewProps extends IObrienAbout23Props<IObrienAbout23Data> {
    obAboutBackground: React.ReactNode;
    obAboutLogo: string;
    obAboutContent: string;
    links1?: React.ReactNode;
    
}

/**
 *
 * ObrienAbout23 component
 * @extends {React.PureComponent<IObrienAbout23Props<IObrienAbout23Data>>}
 */
class ObrienAbout23 extends React.PureComponent<IObrienAbout23Props<IObrienAbout23Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { 
            obAboutBackground,
            links1,
        } = this.props.config;

        //const AboutBackground = config.obAboutBackground ? config.obAboutBackground.src : '';
        const AboutLogo = config.obAboutLogo ? config.obAboutLogo.src : '';
        const AboutContent = config.obAboutContent ? config.obAboutContent : 'No Content';
       
       


        // About Background
        const aboutImageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obAboutBackground && obAboutBackground.imageSettings,
        };
        const aboutImage = obAboutBackground && (
            <Msdyn365.Image {...obAboutBackground} {...aboutImageProps} editProps ={{key:this.props.config.obAboutBackground || {}, requestContext: this.props.context.request}}/>
        );

       
        const contentBlockLinks1 = links1 && links1.length > 0 && <LinksComponent1 {...{ links1 }} />;
        
        const ObrienAbout23Props = {
            ...this.props,
            obAboutBackground: aboutImage,
            obAboutLogo: AboutLogo,
            obAboutContent: AboutContent,
            links1: contentBlockLinks1

        };

        return this.props.renderView(ObrienAbout23Props);
    }
}

export default ObrienAbout23;
